"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductSwitcher = void 0;

var tslib_1 = require("tslib");

var ui_logo_1 = require("@hopin-team/ui-logo");

var ui_menu_1 = require("@hopin-team/ui-menu");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var product_switcher_1 = require("../styled/product-switcher");

var ProductSwitcher = function ProductSwitcher(_a) {
  var products = _a.products,
      _b = _a.menuTitle,
      menuTitle = _b === void 0 ? 'Open product menu' : _b;
  var menuId = (0, use_id_1.useId)();

  var _c = tslib_1.__read((0, react_1.useState)(false), 2),
      isShowing = _c[0],
      setIsShowing = _c[1];

  var isInverse = (0, react_1.useContext)(context_1.TopBarContext).isInverse;

  var getLogo = function getLogo(name) {
    if (name === 'StreamYard') return 'streamyard-pictorial';
    if (name === 'Session') return 'session-pictorial';
    return 'hopin-pictorial';
  };

  return react_1.default.createElement(ui_menu_1.Menu, {
    isShowing: isShowing,
    onClose: function onClose() {
      return setIsShowing(false);
    },
    isDismissible: true,
    isInverse: isInverse
  }, react_1.default.createElement(product_switcher_1.Butticon, {
    icon: "grid-view",
    title: menuTitle,
    onClick: function onClick() {
      return setIsShowing(true);
    },
    id: menuId,
    pattern: isInverse ? 'inverse' : 'secondary'
  }), react_1.default.createElement(product_switcher_1.MenuContent, {
    size: "medium"
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: menuId
  }, products.map(function (product, i) {
    var name = product.name,
        description = product.description,
        onClick = product.onClick;
    return react_1.default.createElement(ui_menu_1.MenuSelectItem, {
      key: i,
      label: name,
      logo: react_1.default.createElement(ui_logo_1.Logo, {
        type: getLogo(name),
        isFlexible: true
      }),
      subtext: {
        label: description,
        position: 'bottom'
      },
      onClick: onClick
    });
  }))));
};

exports.ProductSwitcher = ProductSwitcher;